<ng-container [ngSwitch]="instance.loadableStatus$ | async">
  <ng-container *ngSwitchCase="LoadableStatus.LOADED">
    <div class="d-flex justify-content-between align-items-center cxp-transition mb-0">
      <!-- Left side (title) -->
      <label
        class="text-start cxp-transition h3-500 color-black truncate"
        [ngClass]="(applyTransitionClasses$ | async) ? 'cursor-text' : 'cursor-pointer'"
        [dataSelector]="dataSelector + '-title'"
      >
        {{ name$ | async }}
      </label>

      <!-- Right side (status pill) -->
      <pill
        *ngIf="statusPill$ | async as statusPill"
        [color]="statusPill.color"
        [value]="statusPill.text"
        class="cxp-transition"
        [dataSelector]="dataSelector + '-status-pill'"
      ></pill>
    </div>
    <div class="mt-2 cxp-transition cxp-height-transition">
      <ng-container [ngTemplateOutlet]="clientsTemplate"></ng-container>
    </div>

    <!-- Lock Banner -->
    <div *ngIf="isLocked$ | async" class="lock-banner mt-4" [dataSelector]="dataSelector + '-lock-banner'">
      <aiwyn-icon name="lock" [height]="20" [width]="20" class="lock-banner__icon"></aiwyn-icon>
      <div class="lock-banner__content">
        <span class="h4-500 lock-banner__title">Project is locked</span>
        <span class="body-300 lock-banner__description">
          Request details are no longer accessible. Your deliverables are still available.
        </span>
      </div>
    </div>

    <!-- Deliverables (shown directly when locked, no tabs) -->
    <div *ngIf="isLocked$ | async" class="d-flex flex-column gap-4 align-items-stretch mt-4">
      <ng-container *ngIf="deliverablesCount$ | async; else deliverablesZeroStateTemplate">
        <app-deliverable
          *ngFor="let deliverable of instance.deliverables$ | async"
          [instance]="deliverable"
          [isGroupComplete]="isGroupComplete$ | async"
        ></app-deliverable>
      </ng-container>
    </div>

    <!-- Tab Header with Checkbox (hidden when locked) -->
    <div *ngIf="!(isLocked$ | async)" class="d-flex justify-content-between align-items-end mb-0">
      <mat-tab-group
        [selectedIndex]="selectedTab$ | async"
        mat-align-tabs="start"
        [disableRipple]="true"
        [fitInkBarToContent]="true"
        [mat-stretch-tabs]="false"
        animationDuration="250"
        class="flex-grow-1 tab-bar"
        [ngClass]="{ 'hide-tab-content': !(isSelected$ | async) && (incompleteRequestsCount$ | async) === 0 }"
        [dataSelector]="dataSelector + '-tab-group'"
        (selectedTabChange)="onSelectedTabChange($event.index)"
      >
      <mat-tab>
        <ng-template mat-tab-label>
          <span [dataSelector]="dataSelector + '-requests-tab-label'">
            Requests
          </span>
          @if (hasRejectedItems$ | async) {
            <aiwyn-icon name="alert-circle" class="ms-1 icon-color-red-200" [height]="14" [width]="14" [dataSelector]="dataSelector + '-changes-requested-icon'" title="Changes Requested"></aiwyn-icon>
          }
        </ng-template>

        <div class="cxp-transition primary-client-requests-wrapper primary-client-requests-wrapper-incomplete"
          *ngIf="(requestsCount$ | async); else requestItemsZeroStateTemplate"
        >
          <app-client-request
            *ngFor="let clientRequest of sortedIncompleteRequests$ | async; let index = index"
            [instance]="clientRequest"
            [isGroupSelected]="isSelected$.value"
          ></app-client-request>
          <app-client-request
            *ngFor="let clientRequest of sortedCompleteRequests$ | async"
            [instance]="clientRequest"
            [isGroupSelected]="true"
          ></app-client-request>
        </div>
        <ng-template #requestItemsZeroStateTemplate>
          <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100 p-12 gap-4">
            <h1>No requests available</h1>

            <p class="body-400 color-gray-400 text-center">
              If any requests are shared with you, they'll appear here.
              You'll receive an email notification when requests are ready for you.
            </p>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span [dataSelector]="dataSelector + '-deliverables-tab-label'">Deliverables</span>
        </ng-template>

        <div
          *ngIf="deliverablesCount$ | async; else deliverablesZeroStateTemplate"
          class="d-flex flex-column gap-4 align-items-stretch"
        >
          <app-deliverable
            *ngFor="let deliverable of instance.deliverables$ | async"
            [instance]="deliverable"
            [isGroupComplete]="isGroupComplete$ | async"
          ></app-deliverable>
        </div>

      </mat-tab>
    </mat-tab-group>

    </div>
  </ng-container>

  <div *ngSwitchCase="LoadableStatus.ERROR" class="alert alert--error">
    There was an error loading this client request group.
  </div>

  <div *ngSwitchDefault class="client-request-group-loading"></div>
</ng-container>

<ng-template #clientsTemplate>
  <div *ngIf="clientNames$ | async as clientNames" class="d-flex align-items-center client-names">
    <aiwyn-icon [name]="clientNames.length > 1 ? 'users' : 'user'" [height]="16" [width]="16" class="me-1"></aiwyn-icon>

    <label [ngClass]="{ 'cursor-pointer': !(isSelected$ | async) }">{{ clientNames | join }}</label>
  </div>
</ng-template>


<ng-template #deliverablesZeroStateTemplate>
  <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100 p-12 gap-4">
    <h1>No deliverables available</h1>

    <p class="body-400 color-gray-400 text-center">
      If any deliverables are shared with you, they'll appear here.
      You'll receive an email notification when documents are ready for your review.
    </p>
  </div>
</ng-template>
